import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ThemeModule} from '@drl/theme/theme.module';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import { JoincallComponent } from './joincall.component';

@NgModule({
  declarations: [JoincallComponent],
  imports: [
    CommonModule,
    FormsModule,
    ThemeModule.forRoot(),
    TranslateModule,
  ],
})
export class JoincallModule {}
